import { Props } from '@/components/PageHeader/types';
import Heading from '@/ui/components/Heading/Heading';

const PageHeader = ({ headingText, className = '', value = 2 }: Props) => {
  return (
    <div className={`flex justify-between items-center mb-2 ${className}`}>
      <Heading text={headingText} value={value} />
    </div>
  );
};

export default PageHeader;
